import { render, staticRenderFns } from "./block-legal.vue?vue&type=template&id=1b3c988c&scoped=true"
import script from "./block-legal.vue?vue&type=script&lang=js"
export * from "./block-legal.vue?vue&type=script&lang=js"
import style0 from "./block-legal.vue?vue&type=style&index=0&id=1b3c988c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c988c",
  null
  
)

export default component.exports